import React from 'react';
import { Provider } from 'react-redux';
import store from '../../redux/store';
import CartContent from './CartContent';

const Cart = (props) => (
  <Provider store={store}>
    <CartContent {...props} />
  </Provider>
);

export default Cart;
